import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import { useDocumentTitle } from '@/CandidateExperience/hooks'

import ApplicationListScene from './scenes/ApplicationListScene'
import PageNotFoundScene from './scenes/PageNotFoundScene'

const ApplicationsMain = () => {
  const match = useRouteMatch()

  useDocumentTitle('Applications - OfferZen')

  return (
    <Switch>
      <Route exact path={match.path} render={() => <ApplicationListScene />} />
      <Route component={PageNotFoundScene} />
    </Switch>
  )
}

export default ApplicationsMain
